
import { ListGroups, EquipmentTypeList, IPCLogsList } from '../../Pages';
/* 🧩 COMPONENTS */
import { Button, Breadcrumb } from "../../Components";

import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from 'framer-motion';
import { useSearchParams } from 'react-router-dom';
/* 🎨 STYLES */
import { Container, ContainerButtons } from "./styles";

const validCruds = [ 'groups', 'equipment-types', 'ipc-logs' ];

function EquipCruds() {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();

    const crudParam = searchParams.get('crud');
    const currentList = crudParam && validCruds.includes(crudParam) ? crudParam : 'groups';

    const handleChange = (value) => {
        setSearchParams({ crud: value });
    };


    const navigationFlow =  [
        { text: 'administrative', page: '/adm/equipamentos' },
        { text: 'equipments', page: '/adm/equipamentos' },
        currentList === 'groups'? { text: 'groups', page: '/adm/groups' }
        : currentList === 'equipment-types'? { text: 'equipment-types', page: '/adm/tipos-equipamentos' }
        : { text: 'ipclogs', page: '/adm/ipc-logs' },
    ]

    return (
        <Container>
            <Breadcrumb flow={navigationFlow}/>

            <ContainerButtons>
                <Button
                    id="groups-list-btn"
                    type='button'
                    text={t("administrative.sub-items.groups.sidebar-title")}
                    color={currentList === 'groups'? 'greenSelected': 'green'}
                    onClick={() => handleChange('groups')}
                />
                <Button
                    id="equipment-types-list-btn"
                    type='button'
                    text={t("administrative.sub-items.equipments-types.sidebar-title")}
                    color={currentList === 'equipment-types'? 'greenSelected': 'green'}
                    onClick={() => handleChange('equipment-types')}
                />
                <Button
                    id="ipc-logs-list-btn"
                    type='button'
                    text={t("ipclogs.sidebar-title")}
                    color={currentList === 'ipc-logs'? 'greenSelected': 'green'}
                    onClick={() => handleChange('ipc-logs')}
                />
            </ContainerButtons>

            <AnimatePresence mode="wait">
                <motion.div
                    key={currentList}
                    initial={{ opacity: 0, x: 40 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -40 }}
                    transition={{ duration: 0.3 }}
                >
                    {currentList === 'groups' && <ListGroups />}
                    {currentList === 'equipment-types' && <EquipmentTypeList />}
                    {currentList === 'ipc-logs' && <IPCLogsList />}
                </motion.div>
            </AnimatePresence>
        </Container>
    );
}

export default EquipCruds;